<template>
  <div>
    <div class="container">
      <h1 class="page-title text-center mt-5">Xilda Master</h1>
      <h2 class="sub-title text-center mb-4 mb-md-5">ซิลด้า มาสเตอร์</h2>

      <div v-if="!isDataLoaded">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-9">
            <div class="row mb-3 align-items-end" v-for="index in 3" :key="index">
              <div class="col-12 col-md-5 placeholder">
                <div class="blog-article">
                  <div class="thumbnail mb-3"></div>
                </div>
              </div>
              <div class="col-12 col-md-7 placeholder">
                <div class="blog-article">
                  <div class="paragraph mb-4" style="width: 30%;"></div>
                  <div class="paragraph mb-2" style="width: 100%;"></div>
                  <div class="paragraph mb-2" style="width: 70%;"></div>
                  <div class="paragraph mb-2" style="width: 90%;"></div>
                  <div class="paragraph mt-4" style="width: 80%;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row justify-content-center mb-5" v-for="(item, key) in data" :key="item.id">
          <div class="col-12 col-lg-9">
            <div class="people-box" :class="[key % 2 === 0 ? 'even' : 'odd']">
              <div class="row align-items-center" :class="[key % 2 === 0 ? '' : 'flex-row-reverse']">
                <div class="col-6 col-md-5" :class="[key % 2 === 0 ? 'pr-0' : 'pl-0']">
                  <div class="box-thumbnail">
                    <div class="thumbnail-media" :style="{ backgroundImage: `url(${item._embedded['wp:featuredmedia'][0].media_details.sizes['people-thumbnail'].source_url || ''})` }"></div>
                  </div>
                </div>
                <div class="col-6 col-md-7" :class="[key % 2 === 0 ? 'pl-0' : 'pr-0']">
                  <div class="box-content">
                    <h1 v-html="item.title.rendered"></h1>
                    <p v-if="item.acf.shop_name" v-html="`${$t('message.fromshop')} ${item.acf.shop_name}`"></p>
                    <div class="excerpt d-none d-md-block" v-if="item.excerpt.rendered" v-html="item.excerpt.rendered"></div>
                    <router-link :to="{ name: 'PeopleDetail', params: { slug: decodeURIComponent(item.slug) } }" class="btn dark" v-html="$t('message.viewmore')"></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row my-5" v-if="totalpages > 1">
          <div class="col text-center">
            <button type="button" :class="['btn', currentpage === index ? 'dark' : 'light', 'mr-3', 'pagination', isButtonLoading ? 'disabled': '']" :disabled="isButtonLoading" @click="getData(index)" v-for="(index) in totalpages" :key="index">{{ index }}</button>
          </div>
        </div>
        <!-- /.row -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'XildaMaster',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      isDataLoaded: false,
      data: [],
      page: null,
      per_page: 12,
      currentpage: this.$route.query.paged || 1,
      totalpages: 0,
      isButtonLoading: true
    }
  },
  mounted () {
    document.title = `Xilda Master - ${this.title}`
    this.getData(this.currentpage)
  },
  methods: {
    getData (page = 1) {
      const $vm = this
      const lang = $vm.$route.params.lang
      $vm.isDataLoaded = false
      $vm.isButtonLoading = true
      axios.get(`${$vm.api_path}wp-json/wp/v2/people-category`, {
        params: {
          slug: 'xilda-master'
        }
      }).then(cat => {
        const catId = cat.data[0].id
        axios.get(`${$vm.api_path}wp-json/wp/v2/people`, {
          params: {
            _embed: true,
            'people-category': catId,
            per_page: $vm.per_page,
            page,
            lang
          }
        })
          .then(res => {
            $vm.totalpages = parseInt(res.headers['x-wp-totalpages'])
            $vm.data = res.data
            $vm.isDataLoaded = true
            $vm.$router.push({ query: { paged: page } })
            $vm.currentpage = parseInt(page)
            $vm.page = parseInt(page) + 1
            $vm.isButtonLoading = false
          })
      })
    }
  }
}
</script>
